import { render, staticRenderFns } from "./CallLogTypeList.vue?vue&type=template&id=3dc38912&scoped=true&"
import script from "./CallLogTypeList.vue?vue&type=script&lang=js&"
export * from "./CallLogTypeList.vue?vue&type=script&lang=js&"
import style0 from "./CallLogTypeList.vue?vue&type=style&index=0&id=3dc38912&prod&lang=scss&scoped=true&"
import style1 from "./CallLogTypeList.vue?vue&type=style&index=1&id=3dc38912&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc38912",
  null
  
)

export default component.exports